/*
 * Copyright Camunda Services GmbH and/or licensed to Camunda Services GmbH under
 * one or more contributor license agreements. See the NOTICE file distributed
 * with this work for additional information regarding copyright ownership.
 * Licensed under the Camunda License 1.0. You may not use this file
 * except in compliance with the Camunda License 1.0.
 */

import styled from 'styled-components';
import { TableRow } from '@carbon/react';
import { spacing05 } from '@carbon/layout';

export const StyledTableRow = styled(TableRow)`
  background: var(--cm-color-white-base);
`;

export const TestDataSummary = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
`;

export const TestDataSummarySection = styled.div`
  background: var(--cm-color-white-base);
  padding: 1rem;
`;

export const TestDataSummaryHeader = styled.h4`
  color: var(--cm-color-black-primary-text);
`;

export const TileRow = styled.div`
  display: flex;
  flex-direction: row;
  background: var(--cm-color-white-base);
  justify-content: center;
  margin-top: 1rem;
  gap: 1rem;
  flex-wrap: wrap;
`;

export const StyledTile = styled.div`
  min-width: 360px;
  height: 120px;
  color: var(--cm-color-black-primary-text);
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const TileValue = styled.div`
  font-size: 2.5rem;
  font-weight: 200;
  text-align: center;
  margin-bottom: 0.5rem;
`;

export const ExtractionStatus = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  color: var(--cds-text-secondary);
  font-size: 0.875rem;
`;

export const HeaderWithUploadContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: ${spacing05};
`;
